import PageSettings, { type PageSettingsProps } from "./PageSettings";

/**
 * Scatter History: unified Page Settings modal (fleet sources, filters, Color By, date range).
 */
export default function ScatterHistoryPageSettings(props: PageSettingsProps) {
  return <PageSettings {...props} modalTitle={props.modalTitle ?? "Scatter History settings"} />;
}
